import styled from "styled-components";

export const GrayDiv = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.2rem;
`;

interface IPlateDiv {
  status?: string;
}
export const PlateDiv = styled.div<IPlateDiv>`
  ${(props) => {
    return `
      span {
        background-color: ${
          props.theme.colors.gray72 + props.theme.transparencies.p20
        };
        color: ${props.theme.colors.gray};
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
      }
  `;
  }}
`;

export const PlateBar = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const PlateSection = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  &:hover .tooltip {
    align-items: center;
    display: flex;
    flex-direction: column;
    top: 66%;
    width: 40%;
  }
`;
interface IPlateAmount {
  status?: string;
}
export const PlateAmount = styled.div<IPlateAmount>`
  ${(props) => {
    return `
      span {
        background-color: ${
          props.theme.colors.gray72 + props.theme.transparencies.p20
        };
        color: ${props.theme.colors.gray};
        font-size: 1.1rem;
        font-weight: 600;
        margin-left: 0.3rem;
        padding: 0.6rem;
        width: 1rem;
      }
  `;
  }}
`;
